import {
  Component,
  OnInit,
  ViewChild,
  Input
} from '@angular/core';

import { FormBuilder, FormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { ApService } from 'src/app/shared/services/ap.service';

export interface Authlog {
  _id?: string;
  msg: string;
  t: number; // epoch seconds
}

@Component({
  selector: 'app-device-authlog',
  templateUrl: './device-authlog.component.html',
  styleUrls: ['./device-authlog.component.scss']
})
export class DeviceAuthlogComponent implements OnInit {

  /* RANGE */
  selectedRange: '4h' | '24h' | '7d' | 'thisMonth' | 'lastMonth' = '4h';

  /* FORM */
  form!: FormGroup;

  /* TABLE */
  displayedColumns: string[] = ['message', 'timestamp'];
  _dataSource = new MatTableDataSource<Authlog>([]);

  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  loading = false;

  deviceId!: string;
  orgId?: string;

  pageEvent?: PageEvent;

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @Input() set device(obj: any) {
    if (!obj) return;

    this.deviceId = obj._id;
    this.orgId = obj?.orgId;

    this.resetAndReload();
  }

  constructor(
    private apService: ApService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      search: ['']
    });
  }

  ngOnInit(): void {

    // Debounced search
    this.form.get('search')?.valueChanges
      .pipe(
        debounceTime(400),
        distinctUntilChanged()
      )
      .subscribe(() => {
        this.resetAndReload();
      });

  }

  /* LOAD DATA */
  loadData(): void {
    if (!this.deviceId) return;

    this.loading = true;

    const params: any = {
      range: this.selectedRange,
      page: this.pageEvent?.pageIndex
        ? this.pageEvent.pageIndex + 1
        : 1,
      pageSize: this.pageEvent?.pageSize ?? this.pageSize
    };

    const searchValue = this.form.get('search')?.value;
    if (searchValue) {
      params.search = searchValue;
    }

    this.apService.getAuthlogs(this.deviceId, params)
      .subscribe({
        next: (res: any) => {
          const rows = res?.data ?? res ?? [];

          this._dataSource.data = rows;
          this.length = res?.total ?? rows.length;
          this.loading = false;
        },
        error: (err) => {
          console.error('Failed to load authlogs', err);
          this.loading = false;
        }
      });
  }

  /* TAB CHANGE */
  selectedTabChange(event: MatTabChangeEvent): void {
    const label = event.tab.textLabel;

    switch (label) {
      case 'Last 4 Hrs': this.selectedRange = '4h'; break;
      case 'Last 24 Hrs': this.selectedRange = '24h'; break;
      case 'Last 7 Days': this.selectedRange = '7d'; break;
      case 'This Month': this.selectedRange = 'thisMonth'; break;
      case 'Last Month': this.selectedRange = 'lastMonth'; break;
    }

    this.resetAndReload();
  }

  /* PAGINATION */
  handlePageEvent(event: PageEvent): void {
    this.pageEvent = event;
    this.loadData();
  }

  /* RESET PAGE */
  private resetAndReload(): void {
    this.pageEvent = undefined;

    if (this.paginator) {
      this.paginator.firstPage();
    }

    this.loadData();
  }
}